'use strict';

import React, { Component } from 'react'

import Link  from '@Pure/Link'

import config from '@Config/SynerQuizz/syner_quizz'

import EC_members_config   from '@Config/EC/EC_member'

import { isTrue } from '@root/utility'

const { moment } = window;

export default class SynerQuizzRow extends Component
{
	render ()
	{
		const { data, blank=true, fields, ...props } = this.props;

		moment.locale('fr');

		const blank_props = blank === true
		? { target: '_blank', rel: 'noopener noreferrer' }
		: { };

		const link =
		(
			<Link className="u-link-only" { ...blank_props }
				href={ config.row_link_base + data.id }>
				<span className="u-readers-only">
					Page du Syner'Quizz
				</span>
			</Link>
		);

		const winner_link = data.__winner ?
		(
			<Link className="u-link-only" { ...blank_props }
				href={ EC_members_config.row_link_base + data.winner }>
				<span className="u-readers-only">
					Page du gagnant
				</span>
			</Link>
		)
		: undefined;

		let output =
		(
			<div className="c-dashboard__row">

				<div className="c-dashboard__cell SynerQuizz-title">

					<div className="c-dashboard__long-text">
						{ data.title }
					</div>

					{ link }

				</div>

				<div className="c-dashboard__cell SynerQuizz-start">

					{ moment(data.start).format('dddd DD MMMM HH[:]mm') }

					{ link }

				</div>

				<div className="c-dashboard__cell SynerQuizz-end">

					{ moment(data.end).format('dddd DD MMMM HH[:]mm') }

					{ link }

				</div>

				<div className="c-dashboard__cell SynerQuizz-winner">

					{
						data.__winner ?
						[
							data.__winner.firstname,
							data.__winner.lastname,
							data.__winner.__EC_name
						]
						.filter(str => str && str.trim())
						.join(' ')
						: data.winner
						? 'Compte suspendu'
						: undefined
					}

					{ winner_link }

				</div>

				<div className="c-dashboard__cell SynerQuizz-completed">

					{ isTrue(data.completed) ? 'Oui' : 'Non' }

					{ link }

				</div>

			</div>
		);

		return output;
	}
}